import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { localizedPath } from "../utils/paths";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const { t, i18n } = useTranslation();

  // Extract the locale from the current path
  const pathSegments = location.pathname.split('/');
  const locale = pathSegments[1] || 'en'; // Default to 'en' if locale is not present

  // Construct the localized login path
  const loginPath = localizedPath(locale, "/auth/login");
  const helpPath = localizedPath(locale, "/help");
  const blogsPath = localizedPath(locale, "/blogs");
  const termsPath = localizedPath(locale, "/terms");
  const privacyPath = localizedPath(locale, "/privacy");

  useEffect(() => {
    const storedUser = localStorage.getItem('userProfileData');
    setIsLoggedIn(!!storedUser);
  }, []);

  return (
    <footer className="mt-16 text-center text-sm text-gray-500 border-t pt-6">
      <p className="flex flex-wrap justify-center items-center gap-3">
        <a
          href={helpPath}
          rel="noopener noreferrer"
          className="text-indigo-600 hover:underline"
        >
          {t("help")}
        </a>
        |
        <a
          href={blogsPath}
          className="text-indigo-600 hover:underline"
        >
          {t("blogs_title")}
        </a>
        |
        <a
          href={termsPath}
          className="text-indigo-600 hover:underline"
        >
          {t("terms_conditions")}
        </a>
        |
        <a
          href={privacyPath}
          className="text-indigo-600 hover:underline"
        >
          {t("privacy_policy")}
        </a>
      </p>
    </footer>
  );
};

export default Footer;